import React from 'react';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent } from '@/components/ui/dialog';

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  description: string;
  confirmText: string;
  cancelText?: string;
}

const ConfirmationModal: React.FC<ConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText,
  cancelText = 'Cancel',
}) => {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        data-test-id="confirmation-modal"
        className="bg-app-background border-border/30 max-w-sm mx-4 rounded-xl p-6"
      >
        <div className="text-center space-y-6">
          <div className="space-y-4">
            <h2 className="text-text-primary font-bold text-xl tracking-wide">{title}</h2>
            <p className="text-text-secondary text-sm leading-relaxed">{description}</p>
          </div>

          <div className="space-y-3">
            <Button
              data-test-id="confirm-btn"
              variant="bet99"
              onClick={handleConfirm}
              className="w-full"
            >
              {confirmText}
            </Button>
            <Button
              data-test-id="cancel-btn"
              variant="outline"
              onClick={onClose}
              className="w-full bg-transparent border-bet99-primary text-bet99-primary hover:bg-bet99-primary/10"
            >
              {cancelText}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ConfirmationModal;
